import { useEffect } from 'react';
import { connect } from 'react-redux';
import { modalActions } from '../../reducers/modal.reducer';
import VideoPlayer from '../modal/VideoPlayer.modal';
import Popup from '../modal/Popup.modal';
var EventListener = function EventListener(_ref) {
  var showModalAction = _ref.showModalAction;
  var navigate = useNavigate();
  useEffect(function () {
    $(document).on('click', 'a', function (e) {
      return aHref(e);
    });
    return function () {
      $(document).off('click', 'a', function (e) {
        return aHref(e);
      });
    };
  }, []);
  var aHref = function aHref(e) {
    var href = e.target.href;
    var type = e.target.type;
    if ((type === null || type === void 0 ? void 0 : type.toLowerCase()) === 'internalurl') {
      e.preventDefault();
      href = href.replace(/https?:\/\/posillicowashplant\.com/, '').replace(/https?:\/\/dev.posillicowashplant\.com/, '').replace(window.location.origin, '').replace(/^\//, '');

      // if (href === 'forms') {
      // 	showModalAction({
      // 		component: <Forms />,
      // 	});
      // } else if (href === 'submit-a-project') {
      // 	showModalAction({
      // 		component: <SubmitAProject />,
      // 	});
      // } else {
      navigate(href);
      // }
    } else if ((type === null || type === void 0 ? void 0 : type.toLowerCase()) === 'videopopup') {
      e.preventDefault();
      showModalAction({
        component: /*#__PURE__*/React.createElement(VideoPlayer, {
          url: href
        })
      });
    } else if ((type === null || type === void 0 ? void 0 : type.toLowerCase()) === 'popup') {
      var parts = href.split('/');
      e.preventDefault();
      showModalAction({
        component: /*#__PURE__*/React.createElement(Popup, {
          popupID: parts[parts.length - 1]
        })
      });
    } else {
      // ReactGA.event({
      // 	category: `Washplant ${clientEnv}`,
      // 	action: 'External URL',
      // 	label: href,
      // });
    }
  };
  return null;
};
var mdtp = {
  showModalAction: modalActions.show
};
export default connect(null, mdtp)(EventListener);